import React from 'react';
import EmptyState from '../../../../components/UI/EmptyState';
import styles from '../../../../styles/PerformanceDashboard.module.css';
import { UserPerformanceData } from '../types';

interface RecentActivityProps {
  performanceData: UserPerformanceData;
  formatDate: (dateString: string) => string;
  formatTime: (dateString: string) => string;
}

const RecentActivity: React.FC<RecentActivityProps> = ({
  performanceData,
  formatDate,
  formatTime,
}) => {
  return (
    <div className={styles.activitySection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Recent Activity</h2>
        <p className={styles.sectionSubtitle}>
          Latest task completions and point earnings for {performanceData.user.full_name}
        </p>
      </div>
      {performanceData.recent_activity && performanceData.recent_activity.length > 0 ? (
        <div className={styles.activityList}>
          {performanceData.recent_activity.map((activity, index) => (
            <div key={index} className={styles.activityItem}>
              <div className={styles.activityIcon}>
                {activity.type === 'points_earned' ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 11l3 3L22 4"></path>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                )}
              </div>
              <div className={styles.activityContent}>
                <p className={styles.activityDescription}>{activity.description}</p>
                <p className={styles.activityTime}>
                  {formatDate(activity.timestamp)} at {formatTime(activity.timestamp)}
                </p>
              </div>
              {activity.type === 'points_earned' && activity.points && activity.points > 0 && (
                <div className={styles.activityPoints}>+{activity.points} pts</div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <EmptyState
          image="/images/notasks.png"
          title="No Recent Activity"
          description={`No recent activity recorded for ${performanceData.user.full_name} yet. Activity will appear here once tasks are completed or points are earned.`}
        />
      )}
    </div>
  );
};

export default RecentActivity;

